import { render, staticRenderFns } from "./MinhasComprasDiretas.vue?vue&type=template&id=24e06227&scoped=true"
import script from "./MinhasComprasDiretas.vue?vue&type=script&lang=js"
export * from "./MinhasComprasDiretas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e06227",
  null
  
)

export default component.exports